import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PresetModel } from 'src/app/core/models/classes/preset';
import { RedliningService } from 'src/app/core/services/redlining.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-redliningpresets',
  templateUrl: './redliningpresets.component.html',
  styleUrls: ['./redliningpresets.component.scss'],
})

export class RedliningPresetsComponent implements OnInit {
  presetOptions: PresetModel[] = [];
  sPreset: PresetModel;
  nPreset: PresetModel;
  actionCode: string = '';
  buttontext: string = $localize `SAVE`;
  header: string = '';
  content: string = '';
  splaceholder: string = $localize `Subject`;
  cplaceholder: string = $localize `Comment`;
  chosenItem: number = 0;

  constructor(private presetService: RedliningService, 
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<RedliningPresetsComponent>) 
    {
    this.nPreset = new PresetModel();
    this.sPreset = new PresetModel();
    }

  ngOnInit(): void {
    this.presetService.getPresets().subscribe({
      next: (data) => {
        this.presetOptions = data;
        this.presetOptions.sort((a,b) => a.header.localeCompare(b.header));
      },
    });
  }

  selectedPreset(value: any) {
      this.sPreset = value;     
      this.header = this.sPreset.header;
      this.content = this.sPreset.content;
      this.actionCode = 'Delete enabled';

    if(this.chosenItem === 0)
    {          
      this.chosenItem = this.sPreset.id;     
    }
   else
    {     
      this.chosenItem = this.sPreset.id;
      this.buttontext = $localize `SAVE`;
    }
  }

  onSave() {
    if(this.header !== '' && this.content !== ''){
      //Subject and Content not empty
      if(this.sPreset.id === 0 || this.sPreset.id === undefined){
        //New Preset
        this.sPreset.header = this.header;
        this.sPreset.content = this.content; 
        this.addPreset();             
      }
      else{
        //Existing Preset       
        if(this.buttontext !== $localize `CONFIRM`)
        {
          this.sPreset.header = this.header;
          this.sPreset.content = this.content;
          this.updatePreset();          
        }  
        else
        {
          this.deletePreset();        
          this.header = '';
          this.content = '';
          this.actionCode = '';
          this.buttontext = $localize `SAVE`;
        }                              
      }
    }
    else{
      this._snackBar.open($localize `Subject and/or Content cannot be empty`, '', {
        duration: 3000
      });
    }
  }

  addPreset(){
    this.presetService.redliningPreset(this.sPreset).subscribe({
      next: (data) => {
        if(data.status === 200){
          this.presetService.getPresets().subscribe({
            next: (data) => {
              this.presetOptions = data;
              this.presetOptions.sort((a,b) => a.header.localeCompare(b.header));
              this._snackBar.open($localize `Preset saved successfully`, '', {
                duration: 3000
              });
              this.header = "";
              this.content = "";                  
            },
          });
        }
        else{
          this._snackBar.open($localize `Preset not saved`, '', {
            duration: 3000
          });
        }
      },
    });
  }

  updatePreset(){
    this.presetService.updateRedliningPreset(this.sPreset.id,this.sPreset).subscribe({
      next: (data) => {
        this._snackBar.open($localize `Preset updated successfully`, '', {
          duration: 3000
        });
      },
    });  
  }

  deletePreset(){
    this.presetService.deleteRedliningPreset(this.sPreset.id,this.sPreset).subscribe({
      next: (data) => {
        if(data.status === 200){
          this.presetService.getPresets().subscribe({
            next: (data) => {
              this.presetOptions = data;
              this.presetOptions.sort((a,b) => a.header.localeCompare(b.header));
              this._snackBar.open($localize `Selected Preset has been deleted`, '', {
                duration: 3000
              });
              this.header = "";
              this.content = "";                  
            },
          });
        }             
      },
    });  
  }

  onDelete() {
      this.actionCode = '';
      this.buttontext = $localize `CONFIRM`;  
  }

  onReset() {
    this.sPreset = new PresetModel();
    this.header = '';
    this.content = '';
    this.actionCode = '';
    this.buttontext = $localize `SAVE`;
  }
}
